interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
  disabled?: boolean;
}

export function Toggle({ 
  checked, 
  onChange, 
  label, 
  description, 
  disabled = false 
}: ToggleProps) {
  return (
    <label className={`
      flex items-start gap-3 cursor-pointer select-none
      ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
    `}>
      <div className="relative mt-0.5 min-h-[44px] flex items-center">
        <input
          type="checkbox"
          className="sr-only"
          checked={checked}
          onChange={(e) => !disabled && onChange(e.target.checked)}
          disabled={disabled}
        />
        <div
          className="relative w-[48px] h-[28px] rounded-full transition-all duration-150 ease-in-out"
          style={{
            backgroundColor: checked ? 'var(--link-hover)' : 'var(--surface-container-low)',
            border: checked ? '1px solid var(--link-hover)' : '1px solid var(--outline-variant)',
          }}
        >
          <div
            className={`
              absolute top-1/2 left-[2px] h-[24px] w-[24px] -translate-y-1/2 rounded-full
              transition-transform duration-150 ease-in-out
              ${checked ? 'translate-x-[20px] -translate-y-1/2' : 'translate-x-0 -translate-y-1/2'}
            `}
            style={{
              backgroundColor: checked ? 'var(--surface-container-lowest)' : 'var(--surface-container)',
              boxShadow: '0 1px 3px rgba(0,0,0,0.24)',
            }}
          />
        </div>
      </div>

      <div className="flex flex-col">
        <span className="text-[14px] leading-tight" style={{ color: 'var(--text-secondary)' }}>{label}</span>
        {description && (
          <span className="text-[12px] text-azure-muted mt-0.5">{description}</span>
        )}
      </div>
    </label>
  );
}
